"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
const Badge_styles_1 = require("./Badge.styles");
const setContentType = (hasIcon, hasText) => {
    if (hasIcon && hasText)
        return "textWithIcon";
    if (hasIcon)
        return "icon";
    if (hasText)
        return "text";
    return "empty";
};
/**
 * @deprecated please use <Ds.Badge>New</Ds.Badge> instead
 */
const Badge = (_a) => {
    var { text, dimension = "medium", theme = "solid", luminosity = "high", colour = "red", radius = "regular", icon } = _a, props = __rest(_a, ["text", "dimension", "theme", "luminosity", "colour", "radius", "icon"]);
    const renderBadgeIcon = () => {
        return (react_1.default.createElement(Badge_styles_1.StyledIconContainer, null,
            react_1.default.createElement(__1.Icon, Object.assign({}, icon, { size: 2 }))));
    };
    const renderBadge = () => {
        return (react_1.default.createElement(Badge_styles_1.StyledBadge, Object.assign({ size: dimension, theme: theme, radius: radius, colour: colour, luminosity: luminosity, contentType: setContentType(!!icon, !!text), isClickable: !!props.onClick }, props), (icon || text) && (react_1.default.createElement(Badge_styles_1.StyledBadgeContent, { size: dimension },
            icon && renderBadgeIcon(),
            text && (react_1.default.createElement(__1.Text, { variant: "note", as: "span", skinny: true }, text))))));
    };
    if (props.children) {
        return (react_1.default.createElement(Badge_styles_1.StyledBadgeAnchor, null,
            renderBadge(),
            props.children));
    }
    return renderBadge();
};
exports.Badge = Badge;
//# sourceMappingURL=Badge.js.map